import React from 'react';
import '../styles/theme.css';
import '../styles/Transfer.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import TransferCompletionBand from '../components/TransferCompletionBand';
import TransferInstrumentPanel from '../components/TransferInstrumentPanel';
/* IMPORTS */

function TransferPage() {
  const [transferCompleted, setTransferCompleted] = React.useState(false);

  return (
    <div className="tr-root">
      <div id="transferheader" className="tr-slot-transferheader">
        <Navbar activePage={"Transfer"} />
      </div>
      <div id="transferinstrumentpanel" className="tr-slot-transferinstrumentpanel">
        <TransferInstrumentPanel onTransferComplete={() => setTransferCompleted(true)} />
      </div>
      <div id="transfercompletionband" className="tr-slot-transfercompletionband">
        <TransferCompletionBand completed={transferCompleted} />
      </div>
      <div id="transferfooter" className="tr-slot-transferfooter">
        <Footer />
      </div>
    </div>
  );
}

export default TransferPage;